import { render } from "./AddAccountNumber.vue?vue&type=template&id=2ba98fb0&scoped=true"
import script from "./AddAccountNumber.vue?vue&type=script&lang=js"
export * from "./AddAccountNumber.vue?vue&type=script&lang=js"

import "./AddAccountNumber.vue?vue&type=style&index=0&id=2ba98fb0&scoped=true&lang=css"

import exportComponent from "C:\\chuning\\cn-page\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ba98fb0"]])

export default __exports__